// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dashboard.dashboardPage.title': 'Dashboard',
    'dashboard.dashboardPage.eyebrow': 'Operação',
    'dashboard.dashboardPage.loadError': 'Não foi possível carregar',
    'dashboard.dashboardPage.retry': 'Tentar novamente',
    'dashboard.dashboardPage.kpiRequested': 'Cargas',
    'dashboard.dashboardPage.kpiRequestedHint': 'solicitadas / escaladas',
    'dashboard.dashboardPage.kpiRegions': 'Regiões',
    'dashboard.dashboardPage.kpiRegionsHint': 'com carga solicitada',
    'dashboard.dashboardPage.kpiContracts': 'Contratos',
    'dashboard.dashboardPage.kpiContractsHint': 'com carga solicitada',
    'dashboard.dashboardPage.noDestination': 'Sem destino',
  },
  en: {
    'dashboard.dashboardPage.title': 'Dashboard',
    'dashboard.dashboardPage.eyebrow': 'Operations',
    'dashboard.dashboardPage.loadError': 'Unable to load',
    'dashboard.dashboardPage.retry': 'Retry',
    'dashboard.dashboardPage.kpiRequested': 'Loads',
    'dashboard.dashboardPage.kpiRequestedHint': 'requested / scheduled',
    'dashboard.dashboardPage.kpiRegions': 'Regions',
    'dashboard.dashboardPage.kpiRegionsHint': 'with requested load',
    'dashboard.dashboardPage.kpiContracts': 'Contracts',
    'dashboard.dashboardPage.kpiContractsHint': 'with requested load',
    'dashboard.dashboardPage.noDestination': 'No destination',
  },
  es: {
    'dashboard.dashboardPage.title': 'Panel',
    'dashboard.dashboardPage.eyebrow': 'Operación',
    'dashboard.dashboardPage.loadError': 'No se pudo cargar',
    'dashboard.dashboardPage.retry': 'Reintentar',
    'dashboard.dashboardPage.kpiRequested': 'Cargas',
    'dashboard.dashboardPage.kpiRequestedHint': 'solicitadas / programadas',
    'dashboard.dashboardPage.kpiRegions': 'Regiones',
    'dashboard.dashboardPage.kpiRegionsHint': 'con carga solicitada',
    'dashboard.dashboardPage.kpiContracts': 'Contratos',
    'dashboard.dashboardPage.kpiContractsHint': 'con carga solicitada',
    'dashboard.dashboardPage.noDestination': 'Sin destino',
  },
}
